import { render, staticRenderFns } from "./CareServiceBudgetRecommendation.vue?vue&type=template&id=d7f82f46&"
import script from "./CareServiceBudgetRecommendation.vue?vue&type=script&lang=js&"
export * from "./CareServiceBudgetRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports